module.exports = __webpack_public_path__ + "media/icons/index_phone-7edf9c5b.png";